export default {"src":"/_next/static/media/2.7d3793bb.svg","height":20,"width":9,"blurWidth":0,"blurHeight":0};